import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CustomTooltip({ triggerText, fullText }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <span ref={containerRef} className="relative inline-block">
      <button 
        type="button" 
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="cursor-pointer border-b border-dotted border-ink-secondary/50 text-ink-primary font-medium hover:text-rubric-red hover:border-rubric-red transition-colors bg-transparent p-0 m-0 inline"
      >
        {triggerText}
      </button>
      
      {isOpen && (
        <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-max max-w-[250px] md:max-w-xs bg-white dark:bg-stone-800 text-stone-800 dark:text-stone-200 border border-stone-200 dark:border-stone-700 shadow-lg rounded-md p-3 text-sm font-body">
          {fullText}
          <br/>
          <Link to="/glossaire" className="text-xs text-blue-500 hover:underline mt-1 inline-block">Voir le glossaire</Link>
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-[1px] border-solid border-t-white dark:border-t-stone-800 border-t-8 border-x-transparent border-x-8 border-b-0" />
        </div>
      )}
    </span>
  );
}
